import { all } from 'redux-saga/effects'

import { timer } from './timerSaga.js'
import {
  communicationChannelHandler,
  watchGetState,
  watchOffsetChange,
  watchPlayerStop
} from './communicationSaga'

import {
  watchUpdateSong,
  watchUpdateStatus
} from './electronSaga'

import { isRunningAsElectronApp } from '../lib/environmentUtils'

export default function* rootSaga() {
  yield all([
    communicationChannelHandler(),
    timer(),
    watchGetState(),
    watchOffsetChange(),
    watchPlayerStop(),
    isRunningAsElectronApp() && watchUpdateSong(),
    isRunningAsElectronApp() && watchUpdateStatus()
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/index.js